<!-- eslint-disable prettier/prettier -->
<mat-card appearance="outlined">
	<div class="m-5">
		<mat-card-content>
			<p class="form-subtitle">
				Usaremos este domicilio como tu dirección registrada en Vicente López.
			</p>

			<form [formGroup]="addressForm" class="grid grid-cols-1 gap-6 md:grid-cols-3">
				<!-- Partido -->
				<div>
					<mat-form-field appearance="outline" class="w-full">
						<mat-label>Partido</mat-label>

						<input
							matInput
							formControlName="partidoBusqueda"
							[matAutocomplete]="autoPartidos"
							placeholder="Buscar partido"
							autocomplete="off"
						/>

						<mat-autocomplete
							#autoPartidos="matAutocomplete"
							[displayWith]="displayPartido"
							(optionSelected)="onSeleccionarPartido($event.option.value)"
						>
							@for (partido of partidosFiltrados(); track partido.id) {
							<mat-option [value]="partido"> {{ partido.description }} </mat-option>
							}
						</mat-autocomplete>

						<mat-error>
							@if (addressForm.get('partidoBusqueda')?.touched) { {{
							addressForm.get('partido')!.errors | formErrors }} }
						</mat-error>
					</mat-form-field>
				</div>

				<!-- Calle y altura (col-span-2) -->
				<div class="md:col-span-2">
					<mat-form-field appearance="outline" class="w-full">
						<mat-label>Calle y altura</mat-label>
						<input
							matInput
							formControlName="direccion"
							[matAutocomplete]="autoCallejero"
							[matAutocompleteDisabled]="!isVicenteLopez()"
							placeholder="Ej: Maipú 1234"
						/>
						@if (isLoadingCallejero()) {
						<mat-spinner matSuffix [diameter]="18" class="mr-2"></mat-spinner>
						}
						<mat-autocomplete
							#autoCallejero
							[displayWith]="displayDireccion"
							(optionSelected)="onSeleccionarSugerencia($event.option.value)"
						>
							@for (s of callejeroSugerencias(); track s.place_id) {
							<mat-option [value]="s">{{ s.display_name }}</mat-option>
							}
						</mat-autocomplete>
					</mat-form-field>
					<mat-error>
						@if (addressForm.get('direccion')?.touched) { {{
						addressForm.get('direccion')!.errors | formErrors }} }
					</mat-error>
				</div>

				<!-- Código Postal -->

				<div>
					<mat-form-field appearance="outline" class="w-full">
						<mat-label>Localidad</mat-label>
						<input matInput formControlName="localidad" />
					</mat-form-field>
					<mat-error>
						@if (addressForm.get('localidad')?.touched) { {{
						addressForm.get('localidad')!.errors | formErrors }} }
					</mat-error>
				</div>

				<div>
					<mat-form-field appearance="outline" class="w-full">
						<mat-label>Código Postal</mat-label>
						<input matInput type="number" formControlName="codPostal" />
					</mat-form-field>
					<mat-error>
						@if (addressForm.get('codPostal')?.touched) { {{
						addressForm.get('codPostal')!.errors | formErrors }} }
					</mat-error>
				</div>

				<!-- Localidad -->

				<!-- Piso -->
				<div>
					<mat-form-field appearance="outline" class="w-full">
						<mat-label>Piso</mat-label>
						<input matInput formControlName="piso" />
					</mat-form-field>
				</div>

				<!-- Departamento -->
				<div>
					<mat-form-field appearance="outline" class="w-full">
						<mat-label>Departamento</mat-label>
						<input matInput formControlName="depto" />
					</mat-form-field>
				</div>
			</form>
		</mat-card-content>
	</div>
</mat-card>
